import React, { useEffect, useRef } from "react";
import { NeatGradient } from "@firecms/neat";
import { useEffectiveTheme } from "../../hooks/useEffectiveTheme";
import { getNeatGradientConfig } from "./neatGradientConfig";

/**
 * Single WebGL canvas — mount once via AppGradientBackground.
 * Styled per Neat docs: fixed, full viewport, behind content (z-index: -1).
 */
const NeatGradientCanvas = ({ scrollSync = true, className = "" }) => {
  const canvasRef = useRef(null);
  const gradientRef = useRef(null);
  const isDark = useEffectiveTheme();

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;

    const config = getNeatGradientConfig(isDark);
    gradientRef.current = new NeatGradient({
      ref: canvas,
      ...config,
    });

    const onScroll = () => {
      if (gradientRef.current && scrollSync) {
        gradientRef.current.yOffset = window.scrollY;
      }
    };

    if (scrollSync) {
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }

    return () => {
      if (scrollSync) {
        window.removeEventListener("scroll", onScroll);
      }
      gradientRef.current?.destroy();
      gradientRef.current = null;
    };
  }, [isDark, scrollSync]);

  return (
    <canvas
      ref={canvasRef}
      id="gradient"
      className={className}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: -1,
        pointerEvents: "none",
      }}
    />
  );
};

export default NeatGradientCanvas;
